import { cn } from '@/lib/utils';
import { formatearCRC, formatearCRCEntero } from '@adelante/shared';

interface Props {
  monto: number;
  className?: string;
  titulo?: number;
  decimales?: boolean;
}

export function MontoCRC({ monto, className, titulo, decimales = true }: Props) {
  const texto = decimales ? formatearCRC(monto) : formatearCRCEntero(monto);
  return (
    <span
      className={cn('font-mono tabular-nums', className)}
      title={titulo !== undefined ? formatearCRC(titulo) : undefined}
    >
      {texto}
    </span>
  );
}
